import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import smallModal from 'src/examples/Modal/small';
import mediumModal from 'src/examples/Modal/medium';
import largeModal from 'src/examples/Modal/large';
import extraLargeModal from 'src/examples/Modal/extraLarge';
import oneCTAModal from 'src/examples/Modal/oneCTA';
import twoCTAModal from 'src/examples/Modal/twoCTA';
import twoCTAFullModal from 'src/examples/Modal/twoCTAFull';
import twoCTAPartModal from 'src/examples/Modal/twoCTAPart';
import stepModal from 'src/examples/Modal/step';
import launchModal from 'src/examples/Modal/launch';
import askModal from 'src/examples/Modal/ask';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  smallModal,
  mediumModal,
  largeModal,
  extraLargeModal,
  oneCTAModal,
  twoCTAModal,
  twoCTAFullModal,
  twoCTAPartModal,
  stepModal,
  launchModal,
  askModal,
  React
};